import React from 'react';
import { NavLink } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';

const modules = [
  { key: 'roundrobin', label: 'Round-Robin', icon: '\u21BB', path: '/roundrobin' },
  { key: 'survey', label: 'Survey', icon: '\uD83D\uDCCB', path: '/survey' },
];

export default function Sidebar() {
  const { user } = useAuth();
  const enabledModules = user?.modules || [];

  return (
    <div className="portal-sidebar">
      <nav className="sidebar-nav">
        <NavLink to="/" end className="sidebar-link">
          <span className="sidebar-icon">{'\u2302'}</span>
          <span className="sidebar-label">Dashboard</span>
        </NavLink>

        <div className="sidebar-divider" />

        {modules.map(mod => {
          const enabled = enabledModules.includes(mod.key);

          if (!enabled) {
            return (
              <OverlayTrigger
                key={mod.key}
                placement="right"
                overlay={<Tooltip>Not enabled for your domain</Tooltip>}
              >
                <div className="sidebar-link disabled">
                  <span className="sidebar-icon">{mod.icon}</span>
                  <span className="sidebar-label">{mod.label}</span>
                </div>
              </OverlayTrigger>
            );
          }

          return (
            <NavLink key={mod.key} to={mod.path} className="sidebar-link">
              <span className="sidebar-icon">{mod.icon}</span>
              <span className="sidebar-label">{mod.label}</span>
            </NavLink>
          );
        })}

        {user?.is_super_admin && (
          <>
            <div className="sidebar-divider" />
            <NavLink to="/admin" className="sidebar-link">
              <span className="sidebar-icon">{'\u2699'}</span>
              <span className="sidebar-label">Admin</span>
            </NavLink>
          </>
        )}
      </nav>
    </div>
  );
}
